<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <Team
          :agent="$currentUser"
        />
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <IncomesPayments
          :agent="$currentUser"
        />
      </div>
    </div>
  </div>
</template>
<script>

import Team from "@/components/users/agents/Team.vue";
import IncomesPayments from "@/components/users/agents/IncomesPayments.vue";

export default {
  components: {Team, IncomesPayments},
  data() {
    return {
      loading: false,
    }
  }
}

</script>
